'use client';

import { useCallback } from 'react';
import { fetchDiagnosticPdfAction } from './fetcher';

export const useDownloadPDFDiagnostic = () => {
  return useCallback(fetchDiagnosticPdfAction, []);
};
